import subdomainConfig from "@/config/subdomains";

function detectSubdomain() {
  const hostname = window.location.hostname;

  // 운영환경: 호스트명에서 서브도메인 추출
  // nicelinker.kr, www.nicelinker.kr → null
  // test.nicelinker.kr → 'test'
  const parts = hostname.split(".");
  if (parts.length <= 2) return null;
  const sub = parts[0];
  return sub === "www" || sub === "nicelinker" ? null : sub;
}

const subdomain = detectSubdomain();
const config = subdomain ? (subdomainConfig[subdomain] ?? null) : null;

export default {
  namespaced: true,
  state: () => ({
    subdomain,
    config,
  }),
  getters: {
    subdomain: (state) => state.subdomain,
    isSubdomain: (state) => !!state.config,
    subdomainConfig: (state) => state.config,
    subdomainMenus: (state) => state.config?.menus ?? {},
  },
};
